import { listItemMsg } from '@/shared/components/FormattedListValue';
import { dynamicSort } from '../utils/dynamicSort';

let enumCache;

export function setEnumCache(cache) {
  enumCache = cache;
}

export default {
  get: name => {
    if (!enumCache) return Promise.reject(new Error('EnumCache not initialised'));
    return new Promise((resolve, reject) => enumCache.get(name).then(resolve, reject)); // Convert to real promise instead of angular $q promise
  },
  getTranslated: (name, intl, sortById = false) => {
    if (!enumCache) return Promise.reject(new Error('EnumCache not initialised'));
    return new Promise((resolve, reject) =>
      enumCache.get(name).then(value => {
        const sortFunction =
          typeof sortById === 'function' ? sortById : dynamicSort(sortById ? 'id' : 'label');

        resolve(
          value
            .map(x => ({
              id: x.key,
              label: intl.formatMessage(listItemMsg(name, x.key, x.value)),
            }))
            .sort(sortFunction),
        );
      }, reject),
    ); // Convert to real promise instead of angular $q promise
  },
};
